import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    padding: "32px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 24px 0 #A6A6A633",
    borderRadius: "16px",
    background: "#FFFFFF",
  },
  iconContainer: {
    marginBottom: "16px",
    width: "52px",
    height: "52px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#F7F8F8",
    borderRadius: "50%",
  },
  title: {
    marginBottom: "8px",
    fontSize: "16px",
    lineHeight: "26px",
    fontWeight: 700,
  },
  description: {
    marginBottom: "16px",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "20px",
  },
  startButton: {
    background: "#102B3F",
    padding: "14px 24px",
    borderRadius: "24px",
    fontSize: "15px",
    lineHeight: "23px",
    color: "#FFFFFF",
  },
  dialog: {
    padding: "0 15px",
  },
  dialogTitle: {
    marginBottom: "24px",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "26px",
    color: "#24272A",
  },
  dialogSubtitle: {
    marginBottom: "24px",
    fontWeight: 500,
    fontSize: "17px",
    lineHeight: "17px",
  },
  dividerContainer: {
    marginY: "24px",
  },
  textFieldContainer: {
    marginBottom: "11px",
  },
  avatarTitle: {
    marginBottom: "16px",
    fontWeight: 800,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#24272A",
  },
  croppedImageContainer: {
    position: "relative",
    width: "100px",
  },
  croppedImageEditButton: {
    position: "absolute",
    bottom: "0",
    right: "0",
    backgroundColor: "#00a1ed",
    padding: "11px",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  buttonGroup: {
    display: "flex",
    marginTop: "24px",
    gap: "16px",
    flexDirection: { xxs: "column", md: "row" },
  },
  cancelButton: {
    width: "100%",
    border: "1px solid #E5E5E5",
    borderRadius: "5px",
    height: "50px",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "26px",
    color: "#24272A",
    textTransform: "none",
    letterSpacing: "4%",
  },
  menuPaper: {
    minWidth: "220px",
    marginTop: "7px",
  },
  errorMessage: {
    margin: "7px 14px 0",
    fontSize: "0.75rem",
    color: "rgb(211, 47, 47)",
  },
};
